import api from '../../../../api';
import type { SparkVisibility } from '../content';

export function getSpark(storyId: string, typeId: string, visibility: SparkVisibility) {
    return api.sparks.getOne(storyId, typeId, visibility);
}

export function dismiss(story: string, type: string) {
    return api.sparks.dismiss({ story, type });
}

export function visit(story: string, type: string, visibility: SparkVisibility) {
    return api.sparks.visit({ story, type, visibility });
}

export function isSparkInTimeRange({ startDate = -Infinity, endDate = Infinity }, date: number) {
    return startDate < date && date < endDate;
}
